import React, {useCallback, useState} from 'react';
import {View, Platform, ScrollView} from 'react-native';

import {StyleSheet} from 'react-native';

import {RNEText} from '../../components';
import {width, height, totalSize} from 'react-native-dimension';
import {usePullDownRefreshContext} from '../../stores/pullDownRefreshStore';
import {useFocusEffect} from '@react-navigation/native';

const HelpScreen = () => {
  const {setCanRefresh} = usePullDownRefreshContext();

  const [scrollViewHeight, setScrollViewHeight] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  useFocusEffect(
    useCallback(() => {
      if (scrollViewHeight > 0 && contentHeight > 0) {
        const isScrollable = contentHeight > scrollViewHeight;

        if (!isScrollable) {
          setCanRefresh(true); // always allow pull-down if not scrollable
        } else {
          setCanRefresh(scrollY <= 0); // only allow when scrolled to top
        }
      }
    }, [scrollViewHeight, contentHeight, scrollY, setCanRefresh]),
  );
  const handleScroll = (e: any) => {
    const y = e.nativeEvent.contentOffset.y;
    setScrollY(y);

    const isScrollable = contentHeight > scrollViewHeight;

    if (!isScrollable) {
      setCanRefresh(true); // still always true if no scroll
    } else {
      setCanRefresh(y <= 0); // only true when back at the very top
    }
  };

  return (
    <>
      {Platform.OS === 'web' ? (
        <View style={webStyles.mainContainer}>
          <View style={webStyles.titleContainer}>
            <RNEText
              label="Help"
              variant="header"
              weight="bold"
              color="accent"
            />
          </View>
          <ScrollView style={webStyles.mainWrapper}>
            <View style={webStyles.qaSetContainer}>
              <View style={webStyles.rowContainer}>
                <View style={webStyles.questionLabel}>
                  <RNEText label="Question:" variant="body" weight="bold" />
                </View>
                <RNEText
                  label="How are consultations conducted?"
                  variant="body"
                />
              </View>
              <View style={webStyles.rowContainer}>
                <View style={webStyles.answerLabel}>
                  <RNEText label="Answer:" variant="body" weight="bold" />
                </View>
                <RNEText
                  label="After you search for the doctor of your choice, send out a request for a consultation with them by sending them your first message, which should include why you’re seeking consultation, your symptoms, how the patient feels, medications that the patient has taken, and other interventions that the patient has received. Once this message is sent, wait for the doctor to accept the consultation. Once he/she has accepted the request, the consultation then starts and you can converse with your doctor more. Once your doctor has understood your condition enough, he/she will give out the necessary requests and prescriptions to you. The consultation ends at this point. You can request for another consultation with your doctor after (Please see Requesting for Another Consultation with the Same Doctor)"
                  variant="body"
                />
              </View>
            </View>
            <View style={webStyles.qaSetContainer}>
              <View style={webStyles.rowContainer}>
                <View style={webStyles.questionLabel}>
                  <RNEText label="Question:" variant="body" weight="bold" />
                </View>
                <RNEText
                  label="How much does a consultation cost?"
                  variant="body"
                />
              </View>
              <View style={webStyles.rowContainer}>
                <View style={webStyles.answerLabel}>
                  <RNEText label="Answer:" variant="body" weight="bold" />
                </View>
                <RNEText
                  label="Consultation fees vary per doctor. Make sure that before you request a consultation with a new doctor, check the amount of his/her consultation fee."
                  variant="body"
                />
              </View>
            </View>
            <View style={webStyles.qaSetContainer}>
              <View style={webStyles.rowContainer}>
                <View style={webStyles.questionLabel}>
                  <RNEText label="Question:" variant="body" weight="bold" />
                </View>
                <RNEText
                  label="Can I use one account for multiple people’s check ups?"
                  variant="body"
                />
              </View>
              <View style={webStyles.rowContainer}>
                <View style={webStyles.answerLabel}>
                  <RNEText label="Answer:" variant="body" weight="bold" />
                </View>
                <RNEText
                  label="Housecall gives you the ability to set up multiple profiles under one main account, so you can set up an account for your parents, siblings, etc. When a specific person other than you (main account holder) is the one needing a check up, make sure to choose their profile first before searching for your doctor and requesting a consultation."
                  variant="body"
                />
              </View>
            </View>
          </ScrollView>
        </View>
      ) : (
        <ScrollView
          onScroll={handleScroll}
          onLayout={e => {
            setScrollViewHeight(e.nativeEvent.layout.height);
          }}
          onContentSizeChange={(contentWidth, contentHeight) => {
            setContentHeight(contentHeight);
          }}>
          <View style={mobileStyles.mainContainer}>
            {/* <RNEText
              label="Help"
              variant="header"
              weight="bold"
              color="accent"
              style={{fontSize: Platform.OS === 'ios' ? totalSize(3.5) : totalSize(2.6)}}
            /> */}
            <View style={mobileStyles.qaSetContainer}>
              <View style={mobileStyles.rowContainer}>
                <RNEText
                  label="Question:"
                  variant="body"
                  weight="bold"
                  style={{fontSize: totalSize(1.6)}}
                />
                <RNEText
                  label="How are consultations conducted?"
                  variant="body"
                  style={{fontSize: totalSize(1.6)}}
                />
              </View>
              <View style={mobileStyles.rowContainer}>
                <RNEText
                  label="Answer:"
                  variant="body"
                  weight="bold"
                  style={{fontSize: totalSize(1.6)}}
                />
                <RNEText
                  label="After you search for the doctor of your choice, send out a request for a consultation with them by sending them your first message, which should include why you’re seeking consultation, your symptoms, how the patient feels, medications that the patient has taken, and other interventions that the patient has received. Once this message is sent, wait for the doctor to accept the consultation. Once he/she has accepted the request, the consultation then starts and you can converse with your doctor more. Once your doctor has understood your condition enough, he/she will give out the necessary requests and prescriptions to you. The consultation ends at this point. You can request for another consultation with your doctor after (Please see Requesting for Another Consultation with the Same Doctor)"
                  variant="body"
                  style={{fontSize: totalSize(1.6)}}
                />
              </View>
            </View>
            <View style={mobileStyles.qaSetContainer}>
              <View style={mobileStyles.rowContainer}>
                <RNEText
                  label="Question:"
                  variant="body"
                  weight="bold"
                  style={{fontSize: totalSize(1.6)}}
                />
                <RNEText
                  label="How much does a consultation cost?"
                  variant="body"
                  style={{fontSize: totalSize(1.6)}}
                />
              </View>
              <View style={mobileStyles.rowContainer}>
                <RNEText
                  label="Answer:"
                  variant="body"
                  weight="bold"
                  style={{fontSize: totalSize(1.6)}}
                />
                <RNEText
                  label="Consultation fees vary per doctor. Make sure that before you request a consultation with a new doctor, check the amount of his/her consultation fee."
                  variant="body"
                  style={{fontSize: totalSize(1.6)}}
                />
              </View>
            </View>
            <View style={mobileStyles.qaSetContainer}>
              <View style={mobileStyles.rowContainer}>
                <RNEText
                  label="Question:"
                  variant="body"
                  weight="bold"
                  style={{fontSize: totalSize(1.6)}}
                />
                <RNEText
                  label="Can I use one account for multiple people’s check ups?"
                  variant="body"
                  style={{fontSize: totalSize(1.6)}}
                />
              </View>
              <View style={mobileStyles.rowContainer}>
                <RNEText
                  label="Answer:"
                  variant="body"
                  weight="bold"
                  style={{fontSize: totalSize(1.6)}}
                />
                <RNEText
                  label="Housecall gives you the ability to set up multiple profiles under one main account, so you can set up an account for your parents, siblings, etc. When a specific person other than you (main account holder) is the one needing a check up, make sure to choose their profile first before searching for your doctor and requesting a consultation."
                  variant="body"
                  style={{fontSize: totalSize(1.6)}}
                />
              </View>
            </View>
          </View>
        </ScrollView>
      )}
    </>
  );
};

export default HelpScreen;

const webStyles = StyleSheet.create({
  mainContainer: {
    paddingTop: 140,
    paddingBottom: 32,
    paddingHorizontal: 80,
    width: '100%',
    flex: 1,
  },
  titleContainer: {
    marginBottom: 40,
  },
  mainWrapper: {
    paddingRight: 48,
  },
  qaSetContainer: {
    marginVertical: 24,
  },
  rowContainer: {
    flexDirection: 'row',
    // justifyContent: 'space-between',
    marginVertical: 16,
  },
  questionLabel: {
    width: 116,
  },
  answerLabel: {
    width: 116,
  },
});

const mobileStyles = StyleSheet.create({
  mainContainer: {
    paddingVertical: Platform.OS === 'android' ? height(0.5) : height(2.5),
    paddingHorizontal: width(6),
  },
  qaSetContainer: {
    // marginVertical: height(1),
  },
  rowContainer: {
    justifyContent: 'space-between',
    marginVertical: height(1),
  },
});

const sharedStyles = StyleSheet.create({
  root: {
    height: '100%',
    flexDirection: 'row',
    width: '100%',
  },
});
